<template>
    <div v-if="showModal">
        test
        <b-modal
                v-model="showModalLocal"
                :title="'Разделение туристов по ' + (mode==='invoice'?'счетам':'договорам')"
                class="modal-primary"
                size="md"
                ok-variant="primary"
                @hide.prevent
                @ok="handleOk"
                @cancel="handleCancel"
                @close="handleCancel"
                ref="my-modal"
        >

            <p><small>Автоматически создаются счета - один общий, на имя заказчика, и по дополнительному на каждого из
                туристов. Каждому туристу необходимо назначить счет, в котором будет учтена его путевка.
                Печатаются только те счета, которые назначены одному или нескольким туристам.</small></p>

            <table class="table table-sm table-bordered table-hover">
                <tr>
                    <td>основной</td>
                    <td>
                        {{ voucherx.contact_name }}
                        <br/><small>заказчик</small>
                    </td>
                </tr>
                <tr v-for="g,i in guestsx">
                    <td>
                        доп/{{g.invoice_subid}}
                    </td>
                    <td>
                        <template v-if="is(g.surname) || is(g.name_) || is(g.patro)">
                            {{ g.surname }} {{ g.name_ }} {{ g.patro }}
                            <br/><small>турист: {{ getProgramTitleById(g.t_obj_tariff_id, programsx) }}</small>
                        </template>
                        <template v-else>
                            не указано
                        </template>
                    </td>
                    <td>
                        <b-select
                            :options="getInvoices"
                            v-model="g.invoice_subgrp"
                            value-field="id"
                            text-field="title"
                        ></b-select>
                    </td>
                </tr>
            </table>


            <b-form-group>
                <b-form-checkbox-group stacked id="basicCustomCheckboxes">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="faximile" value="1" checked v-model="voucherx.faximile">
                        <label class="custom-control-label" for="faximile">Печать факсимиле</label>
                    </div>
                </b-form-checkbox-group>
            </b-form-group>

            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Сохранить и напечатать
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions';
    import { functions_loaders } from '@/functions_loaders';
    import { functions_program } from '@/functions/program.js';
    import {CONSTANTS} from '@/constants'

    export default {
        name: 'InvoicesSplitDialog',
        mixins: [functions, functions_loaders, functions_program ],
        data: function () {
            return {

            };
        },
        model: {
            prop: "showModal",
            event: "hide",
        },
        props: {
            showModal: [Number, Boolean],
            voucherx: Object,
            guestsx: Array,
            programsx: Array,
            mode: String
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                //console.log('SimpleDialog: handleCancel');
                this.$emit("hide", false);
            },
            handleOk: function () {
                //console.log('SimpleDialog: handleOk');
                this.$emit("print");
                this.$emit("hide", false);
            },
            handleSubmit: function () {
                //console.log('SimpleDialog: handleSubmit');
                this.$emit("print");
                this.$emit("hide", false);
            },
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return this.showModal
                },
                set: function (newValue) {}
            },
            getInvoices: function() {
                let invoices = [
                    {id:0, title:'основной'}
                ];
                for (let i=0; i<this.guestsx.length;i++) {
                    let j = i+1;
                    let id = this.guestsx[i].invoice_subid;
                    invoices.push({id:j, title:'доп/'+id})
                }
                return invoices;
            }
        },
        created: function() {
        },
        mounted: function() {
            //console.log('SimpleDialog: mounted');
        },
        updated: function() {
            console.log('SimpleDialog: updated');

        },
    }
</script>
